import { ReactElement } from 'react';
import { isMobile } from 'utils/is-mobile';
import { FavoriteSkeletonHeader } from 'components/Shared/Favorites/FavoriteSkeletonHeader';
import { CompetitionSkeleton } from 'components/UI/Skeletons/CompetitionSkeleton';

const COMPETITION_SKELETON_COUNTS = {
  mobile: 5,
  desktop: 1
};

const skeletonsCount =
  COMPETITION_SKELETON_COUNTS[isMobile() ? 'mobile' : 'desktop'];

export const FavoritesSkeleton = (): ReactElement => {
  return (
    <>
      <FavoriteSkeletonHeader />
      <CompetitionSkeleton count={skeletonsCount} />
    </>
  );
};
